import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "../../services/hooks";
import { logout } from "../../services/login/actions";
import styles from "./header.module.css";

export function AppHeader(): JSX.Element {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((store) => store.loginReducer.user);

  const handleLogout = (): void => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <>
      <div className={styles.topbar}>
        <div className={styles.left}>
          <img className={styles.logo} src="/logo.png" alt="Webtypist logo" />

          <div className={styles.brand}>
            <div className={styles.title}>Webtypist</div>
            <div className={styles.sub}>type • train • have • fun</div>
          </div>
        </div>

        <div className={styles.authControls}>
          {user ? (
            <>
              <NavLink to="/profile" className={styles.authLink}>
                <span className={styles.icon} aria-hidden="true">
                  <svg className={styles.iconSvg} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" strokeWidth="1.8" />
                    <path d="M4 21C4 17.6863 7.58172 15 12 15C16.4183 15 20 17.6863 20 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                </span>
                <span>{user.username}</span>
              </NavLink>

              <button
                type="button"
                className={styles.logoutButton}
                aria-label="Logout"
                onClick={handleLogout}
              >
                <span className={styles.icon} aria-hidden="true">
                  <svg className={styles.iconSvg} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 21H5C4.44772 21 4 20.5523 4 20V4C4 3.44772 4.44772 3 5 3H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M21 12H10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                </span>
              </button>
            </>
          ) : (
            <NavLink to="/login" className={styles.authLink}>
              Login
            </NavLink>
          )}
        </div>
      </div>

      <div className={styles.stripe} aria-hidden="true" />

      <nav className={styles.nav}>
        <>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? styles.active : undefined
            }
          >
            Trainer
          </NavLink>

          <NavLink
            to="/trials"
            className={({ isActive }) =>
              isActive ? styles.active : undefined
            }
          >
            Trials
          </NavLink>

          <NavLink
            to="/drill"
            className={({ isActive }) =>
              isActive ? styles.active : undefined
            }
          >
            Drill
          </NavLink>

          <NavLink
            to="/highscores"
            className={({ isActive }) =>
              isActive ? styles.active : undefined
            }
          >
            Highscores
          </NavLink>
        </>
      </nav>
    </>
  );
}
